<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page edit-massive-invoice">
    
    <div class="mb-1"><small >Raggruppati per mese competenza</small></div>
    <DataTable ref="dt" :value="items" responsiveLayout="scroll">
      <template #header>
        <div class="flex justify-content-end flex-wrap">
          <div class="flex align-items-center justify-content-center">
            <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV($event)" class="p-button-primary" />
          </div>
        </div>
      </template>
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template>
      <!-- <Column selectionMode="multiple" /> -->
      <Column field="date" header="Mese Fatturazione" :sortable="true"></Column>
      <Column field="n_fatture" header="N. Fatture" :sortable="true"></Column>
      <Column field="tot_fatture" header="Tot. Fatture" :sortable="true">
        <template field="tot_fatture" #body="{data}">
          {{formatCurrency(data.tot_fatture)}}     
        </template>
      </Column>
      <Column field="tot_pagato" header="Tot. Pagato" :sortable="true">
      <template field="tot_pagato" #body="{data}">
          {{formatCurrency(data.tot_pagato)}}     
        </template>
      </Column>
      <Column field="tot_saldo" header="Tot. Saldo" :sortable="true">
      <template field="tot_saldo" #body="{data}">
          {{formatCurrency(data.tot_saldo)}}     
        </template>
      </Column>
    </DataTable>

  </div>

  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <!-- <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        /> -->
    </div>
  </div>

</template>

<script>


import { ref, getCurrentInstance, onMounted } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import moment from 'moment';


export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'fattura-riepilogo-ciclo-mesi'}
    const loader = ref(false)
    const dt = ref();
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const items = ref()

    onMounted(() =>{
      getGroupTotalByDate(props.data)
    })

    const getGroupTotalByDate = (data) => {

      let group = data.reduce(function (r, a) {
          let d = moment(a.mese_fatturazione).format('YYYY-MM')
          r[d] = r[d] || [];
          r[d].push(a);
          return r;
      }, {});
      
      let result = []
      for (const [date, els] of Object.entries(group)) {
        let obj = {
          n_fatture: 0,
          tot_fatture: 0,
          tot_pagato: 0,
          tot_saldo: 0,
          date: moment(new Date(date)).locale('it').format('MMM YYYY').toUpperCase()
        }
        els.forEach(el => {
          obj.n_fatture += 1
          obj.tot_fatture += el.totale_fattura
          obj.tot_pagato += el.pagato
          obj.tot_saldo += el.saldo;
          
        });

        result.push(obj)
      }
      items.value = result.map((el) => {
        el.tot_fatture = el.tot_fatture.toFixed(2)
        el.tot_pagato = el.tot_pagato.toFixed(2)
        el.tot_saldo = el.tot_saldo.toFixed(2)
      })
      items.value = result
    }

    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const exportCSV = () => {
      dt.value.exportCSV();
    };

    const formatCurrency = (value) => {
      let v = parseFloat(value)
      return v.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    }


    return {
      page,
      items,
      dt,
      loader,
      onCancelButton,
      formatDate,
      filters,
      exportCSV,
      formatCurrency
    }
  }
}


</script>


